import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { RandomUtils } from '../../utils/random.utils';

interface OverlayContainerHolder {
  element: WeakRef<HTMLElement>;
  count: number;
}

@Injectable({
  providedIn: 'root',
})
export class OverlayContainerController {
  private _overlayContainerMap = new WeakMap<
    HTMLElement,
    OverlayContainerHolder
  >();

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  appendElementToContainer(container: HTMLElement, element: HTMLElement) {
    let overlayContainer: HTMLElement;
    let holder: OverlayContainerHolder;

    if (this._overlayContainerMap.has(container)) {
      holder = this._overlayContainerMap.get(container);
    }

    overlayContainer = holder?.element?.deref();

    if (!overlayContainer) {
      overlayContainer = this._document.createElement('div');
      overlayContainer.setAttribute(
        'id',
        `overlay-container-${RandomUtils.uniqId()}`
      );
      overlayContainer.style.setProperty('display', 'contents');
      overlayContainer.style.setProperty('z-index', '999');
      container.appendChild(overlayContainer);

      holder = { count: 1, element: new WeakRef(overlayContainer) };
      this._overlayContainerMap.set(container, holder);
    } else {
      ++holder.count;
    }

    overlayContainer.appendChild(element);
  }

  removeElementFromContainer(container: HTMLElement, element: HTMLElement) {
    if (this._overlayContainerMap.has(container)) {
      const holder = this._overlayContainerMap.get(container);
      const overlayContainer = holder.element?.deref();
      if (overlayContainer) {
        if (element) {
          overlayContainer.removeChild(element);
        }

        --holder.count;

        if (holder.count < 1) {
          container.removeChild(overlayContainer);

          this._overlayContainerMap.delete(container);
        }
      }
    }
  }
}
